import React from "react";
const style:any = {
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: 0,
    lineHeight: '23px',
    textAlign: 'center',
    height: '50px',
    width: '240px',
    borderRadius: '25px',
    backgroundColor: '#00ABCA',
    fontFamily: 'Asap',
    border:'none',
    cursor: 'pointer'
}
interface HomeButtonProps {
    text: string;
    onClick(event: any): void;
}
export default React.memo((props: HomeButtonProps)=>(
    <button style={style} onClick={props.onClick}>{props.text}</button>
))


// WEBPACK FOOTER //
// ./src/pages/home/components/HomeButton.tsx